import { RestApi } from '@maverick/http';

export const createApiClient = (isOrder: boolean) => {
    const baseUrl = isOrder ? '/order/api/nativeAuth' : '/api/nativeAuth';
    return new RestApi(baseUrl);
};
